export const kotiTitleGenerator = (text) => {
    return `koti | ${text}`
}

export const kotiImageAltGenerator = (text) => {
    return kotiTitleGenerator(text)
}